import styled from 'vue-styled-components';
import theme from '@/config/theme';

export const Container = styled.main`
  > div {
    display: grid;
    grid-auto-flow: column;
    justify-content: space-between;
    
    & .containerIcons {
      grid-column-end: 4;
      display: flex;
      column-gap: 1rem;

      & button {
        display: flex;
        align-items: center;
        background-color: ${theme.colors.white};
        border: 1px solid #dee1db;
        box-sizing: border-box;
        border-radius: 50%;
        padding: 0.3rem;
        outline: none;

        &:hover {
          cursor: pointer;
          transform: scale(1.1);

        }

        & svg {
          color: ${theme.colors.primaryBlue};
          width: 18px;
          height: 16px;
        }
        h1{
          color: white;
        }
      }
    }

    @media screen and (max-width: ${theme.grid.tablet.breakpoint}) {
      justify-content: flex-end;
      padding-bottom: 60px !important;
    }
  }

  @media screen and (max-width: ${theme.grid.tablet.breakpoint}) {
    padding-top: 140px !important;
  }
`;
